import { createFileRoute } from "@tanstack/react-router";
import AdminCRM from "@/pages/admin/AdminCRM";

export const Route = createFileRoute("/_adminLayout/admin/crm")({
  component: AdminCRM,
});
